"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ObjectEvent = void 0;

var _Event = _interopRequireDefault(require("./events/Event.js"));

var _ObjectEventType = _interopRequireDefault(require("./ObjectEventType.js"));

var _Observable = _interopRequireDefault(require("./Observable.js"));

var _obj = require("./obj.js");

var _util = require("./util.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/Object
 */


/**
 * @classdesc
 * Events emitted by {@link module:ol/Object~BaseObject} instances are instances of this type.
 */
var ObjectEvent =
/** @class */
function (_super) {
  __extends(ObjectEvent, _super);
  /**
   * @param {string} type The event type.
   * @param {string} key The property name.
   * @param {*} oldValue The old value for `key`.
   */


  function ObjectEvent(type, key, oldValue) {
    var _this = _super.call(this, type) || this;
    /**
     * The name of the property whose value is changing.
     * @type {string}
     * @api
     */


    _this.key = key;
    /**
     * The old value. To get the new value use `e.target.get(e.key)` where
     * `e` is the event object.
     * @type {*}
     * @api
     */

    _this.oldValue = oldValue;
    return _this;
  }

  return ObjectEvent;
}(_Event["default"]);

exports.ObjectEvent = ObjectEvent;

/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<import("./ObjectEventType").Types, ObjectEvent, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types, Return>} ObjectOnSignature
 */

/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable~Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @api
 */
var BaseObject =
/** @class */
function (_super) {
  __extends(BaseObject, _super);
  /**
   * @param {Object<string, *>} [opt_values] An object with key-value pairs.
   */


  function BaseObject(opt_values) {
    var _this = _super.call(this) || this;
    /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */


    _this.on;
    /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */

    _this.once;
    /***
     * @type {ObjectOnSignature<void>}
     */

    _this.un; // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
    // the same as the order in which they were created.  This also helps to
    // ensure that object properties are always added in the same order, which
    // helps many JavaScript engines generate faster code.

    (0, _util.getUid)(_this);
    /**
     * @private
     * @type {Object<string, *>}
     */

    _this.values_ = null;

    if (opt_values !== undefined) {
      _this.setProperties(opt_values);
    }

    return _this;
  }
  /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */


  BaseObject.prototype.get = function (key) {
    var value;

    if (this.values_ && this.values_.hasOwnProperty(key)) {
      value = this.values_[key];
    }

    return value;
  };
  /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */


  BaseObject.prototype.getKeys = function () {
    return this.values_ && Object.keys(this.values_) || [];
  };
  /**
   * Get an object of all property names and values.
   * @return {Object<string, *>} Object.
   * @api
   */


  BaseObject.prototype.getProperties = function () {
    return this.values_ && (0, _obj.assign)({}, this.values_) || {};
  };
  /**
   * @return {boolean} The object has properties.
   */


  BaseObject.prototype.hasProperties = function () {
    return !!this.values_;
  };
  /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */


  BaseObject.prototype.notify = function (key, oldValue) {
    var eventType;
    eventType = "change:".concat(key);

    if (this.hasListener(eventType)) {
      this.dispatchEvent(new ObjectEvent(eventType, key, oldValue));
    }

    eventType = _ObjectEventType["default"].PROPERTYCHANGE;

    if (this.hasListener(eventType)) {
      this.dispatchEvent(new ObjectEvent(eventType, key, oldValue));
    }
  };
  /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */


  BaseObject.prototype.addChangeListener = function (key, listener) {
    this.addEventListener("change:".concat(key), listener);
  };
  /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */


  BaseObject.prototype.removeChangeListener = function (key, listener) {
    this.removeEventListener("change:".concat(key), listener);
  };
  /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [opt_silent] Update without triggering an event.
   * @api
   */


  BaseObject.prototype.set = function (key, value, opt_silent) {
    var values = this.values_ || (this.values_ = {});

    if (opt_silent) {
      values[key] = value;
    } else {
      var oldValue = values[key];
      values[key] = value;

      if (oldValue !== value) {
        this.notify(key, oldValue);
      }
    }
  };
  /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Object<string, *>} values Values.
   * @param {boolean} [opt_silent] Update without triggering an event.
   * @api
   */


  BaseObject.prototype.setProperties = function (values, opt_silent) {
    for (var key in values) {
      this.set(key, values[key], opt_silent);
    }
  };
  /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */


  BaseObject.prototype.applyProperties = function (source) {
    if (!source.values_) {
      return;
    }

    (0, _obj.assign)(this.values_ || (this.values_ = {}), source.values_);
  };
  /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [opt_silent] Unset without triggering an event.
   * @api
   */


  BaseObject.prototype.unset = function (key, opt_silent) {
    if (this.values_ && key in this.values_) {
      var oldValue = this.values_[key];
      delete this.values_[key];

      if ((0, _obj.isEmpty)(this.values_)) {
        this.values_ = null;
      }

      if (!opt_silent) {
        this.notify(key, oldValue);
      }
    }
  };

  return BaseObject;
}(_Observable["default"]);

var _default = BaseObject;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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